import React from "react";
import { PiMusicNotes } from "react-icons/pi";

const EmptyState: React.FC<{
  title: string;
  text: string;
  children?: React.ReactNode; // action buttons
}> = ({ title, text, children }) => (
  <div className="w-full min-h-[400px] bg-secondary p-8 rounded-3xl flex flex-col items-center justify-center text-center gap-2.5">
    <span className="w-14 h-14 rounded-full bg-white text-primary grid place-items-center text-[28px]">
      <PiMusicNotes />
    </span>
    <h2 className="mt-1 text-lg font-semibold">{title}</h2>
    <p className="text-black41 max-w-[42ch]">{text}</p>
    {children && <div className="flex flex-wrap justify-center gap-3 mt-2">{children}</div>}
  </div>
);

export default EmptyState;
